var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcDropImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "78px",
    height: "89px",
    viewBox: "0 0 78 89",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "IMAGE A&lt;RROW") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "CHAPTER-#1",
    transform: "translate(-539.000000, -1787.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "IMAGE-A<RROW",
    transform: "translate(539.296833, 1787.947750)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    stroke: "#FAFAFA",
    strokeWidth: 7,
    fill: "#EFEFEF",
    transform: "translate(38.690394, 38.690394) rotate(-11.000000) translate(-38.690394, -38.690394) ",
    x: 9.1903939,
    y: 9.1903939,
    width: 59,
    height: 59
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-3",
    fill: "#B2B2B2",
    points: "42.6844915 84.5145588 49.0009593 78.12425 52.484771 87.7333502 57.2356007 85.5966489 53.9623728 76.5226682 62.0675645 76.5226682 42.6844915 52.7815424"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDropImage);
export default __webpack_public_path__ + "static/media/ic_drop_image.edebdcaec7f54be01a803fed393ee0c8.svg";
export { ForwardRef as ReactComponent };